<template>
  <div class="page2_wrapper">
    <div class="container">
      <div class="main" v-loading="loading">
        <div class="right">
          <div class="breadcrumb">
            <div class="lable">当前位置:</div>
            <div class="breadcrumb_item">
              <div @click="returnPre(0)">首页</div>
              <div @click="returnPre(1)">
                <span>></span>
                {{ parentActiveTab.label }}
              </div>
              <!--<div @click="returnPre(2)"><span>></span>{{childActiveTab.label}}</div>-->
            </div>
          </div>
          <div class="groupbtn">
            <div>
              <div v-if="+pjnotice.btnstatus < 3">
                <div v-if="isbmflag">
                  <el-button type="primary" @click="goybm" :loading="btnLoading">已报名</el-button>
                </div>
                <div v-else>
                  <el-button type="primary" @click="gobm" :loading="btnLoading">去报名</el-button>
                </div>
              </div>
              <div v-else-if="+pjnotice.btnstatus === 4">
                <el-button type="primary" @click="gobj" :loading="btnLoading">{{ prsname }}</el-button>
              </div>
            </div>
            <div v-if="+pjnotice.btnstatus !== 5 && pjnotice.alertmsg">
              <div class="countdown">
                <span>{{ pjnotice.alertmsg }}</span>
                <count-down v-if="pjnotice.btnstatus !== 5 && pjnotice.btnstatusdesc" :enddate="pjnotice.enddate">
                </count-down>
              </div>
            </div>
          </div>
          <div v-if="isbmflag" class="alertmsg">（点击已报名进入工作台查看报名信息）</div>
          <div>
            <div class="pjnoticeTitle">{{ pjnotice.pjnoticetitle }}</div>
            <div v-html="pjnotice.pjnoticedesc" class="content"></div>
            <div>
              <!-- 附件 -->
              <div style="display: flex; margin: 0 0 22px 22px">
                <div style="margin-right: 20px">公告附件:</div>
                <div v-if="pjnodeAppendList.length" class="filelist">
                  <div v-for="(item, index) in pjnodeAppendList" :key="index" class="fileitem">
                    <div class="name" @click="downFile(item.appendurl)">
                      <a :src="uploadAddr + item.appendurl">
                        {{
                        item.appendfilename
                        }}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="filelist" v-else>无</div>
              </div>
            </div>
          </div>
          <div class="otherNotice" style="display: flex; margin: 0 0 22px 22px" v-if="otherNotice.length > 0">
            <div class="label">相关公告：</div>
            <div class="value">
              <div class="value-list noticlink" style="cursor: pointer;margin-bottom: 15px;"
                @click="toProjectInfo(item)" v-for="item in otherNotice" :key="item.pjnoticeid">
                {{item.pjnoticetitle}}
              </div>
            </div>
          </div>
        </div>
        <div class="dialog">
          <el-dialog :close-on-click-modal="false" @close="close" :visible.sync="dialogVisible" :width="dialogWidth">
            <little-login v-if="dialogType === 1" @change="close"></little-login>
            <psu v-if="dialogType === 2" :projectid="pjnotice.pjnoticeprojectid" @change="close"></psu>
            <!--<div v-if="dialogType === 2">-->
            <!--报名成功，请点击确定登录后台维护报名详细信息！-->
            <!--<el-button type="primary" @click="goLink">确 定</el-button>-->
            <!--</div>-->
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CountDown from './common/CountDown'
// import Nav from './common/Nav'
import LittleLogin from './common/LittleLogin'
import Psu from './common/Psu'
// import ProjectNotice from './common/ProjectNotice'
// import ProjectResultNotice from './common/ProjectResultNotice'
import _ from 'lodash'
import request from '@/utils/request'
import common from '@/mixin/common'
import dayjs from 'dayjs'

export default {
  name: 'pjnoticeInfo',
  mixins: [common],
  components: { LittleLogin, Psu, CountDown },
  data() {
    return {
      creenWidth: document.body.clientWidth,
      btnLoading: false,
      loading: false,
      dialogTitle: '',
      dialogVisible: false,
      dialogWidth: '455px',
      dialogType: 0,
      swiperList: [],
      navs: [],
      total: 0,
      pageSize: 7,
      query: {
        currentPage: 1,
        offset: 0
      },
      list: [],
      activeIndex: '',
      debouncedGetAnswer: '',
      last: '',
      // bmDisplay: true,
      isbmflag: false,
      isbjflag: false,
      userProjectList: [],
      pjnotice: {},
      appendList: [],
      pjnodeAppendList: [],
      otherNotice: []
    }
  },
  async created() {
    this.getScreen()
    // this.getList()
    await this.getpjnotice()
    await this.getOtherNotice()
    if (this.webLoginUser) {
      await this.getPsuListByComId()
    }
  },
  watch: {},
  mounted() {
    this.setMobile()
  },
  destroyed() {
    window.removeEventListener('resize', this.getScreen)
  },
  methods: {
    getScreen() {
      let clientWidth = document.documentElement.clientWidth || document.body.clientHeight
      if (clientWidth < 768) {
        this.dialogWidth = '90%'
      } else {
        this.dialogWidth = '40%'
      }
    },
    setMobile() {
      addEventListener('resize', () => {
        this.getScreen()
      })
    },
    async getPsuListByComId() {
      let res = await request({
        method: 'get',
        url: '/web/web/getPsuListByComId',
        params: {
          projectid: this.pjnotice.pjnoticeprojectid || 0,
          comid: this.webLoginUser.usercomid,
          cosid: this.webLoginUser.cosid,
          total: 0,
          limit: 1,
          offset: 0
        }
      })
      if (res.count[0].count > 0) {
        this.isbmflag = true
        this.isbjflag = true
      } else {
        this.isbmflag = false
        this.isbjflag = false
      }
    },
    async getProject() {
      let res = await request({
        method: 'get',
        url: '/web/web/getProjectById',
        params: { projectid: this.pjnotice.pjnoticeprojectid }
      })
      return res[0]
    },
    async getpjnotice() {
      this.loading = true
      let res = await request({
        method: 'get',
        url: '/web/web/getpjnotice',
        params: { pjnoticeid: this.$route.query.pjnoticeid }
      })

      this.pjnotice = res
      this.pjnodeAppendList = res.pjnodeAppendList
      this.loading = false
    },
    async goLink() {
      if (!this.webLoginUser) {
        return
      }
      if (+this.webLoginUser.comid === +this.pjnotice.cusercomid) {
        this.$message({
          message: `该项目发布单位是${this.webLoginUser.comfullname}，不允许报名！`,
          type: 'warning'
        })
        return
      }
      if (+this.webLoginUser.comtype !== 3) {
        this.$message({
          message: '您不是供应商角色，不允许报名！',
          type: 'warning'
        })
        return
      }

      let res = await request({
        method: 'get',
        url: '/web/web/getPsuhasPayfee',
        params: {
          comid: this.webLoginUser.comid,
          cosid: this.webLoginUser.cosid
        }
      })
      if (res > 0) {
        this.$confirm(
          `<p>您单位存在<span style="color:red;">未缴纳服务费的成交记录</span>，请先缴纳服务费，才能进行本项目报名。</p><br/>
<p>请您同时上传该成交记录项目的合同扫描文件，平台收到后将退还您的保证金。</p>`,
          '温馨提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            customClass: 'winClass',
            type: 'warning'
          }
        ).then(() => {
          window.location.replace(`${this.obWebUrl}?t=${this.webLoginUser.token}&formname=psuServicepayIndex&menuid=64`)
        })
        return
      }

      let newProject = await this.getProject()
      if (dayjs(newProject.prsbmbegtime).valueOf() > dayjs().valueOf()) {
        this.$message({
          message: '该项目报名时间还未开始，不能报名！',
          type: 'warning'
        })
        return
      }
      if (!(dayjs(newProject.prsbmbegtime).valueOf() < dayjs().valueOf() && dayjs(newProject.prsbmendtime).valueOf() > dayjs().valueOf())) {
        this.$message({
          message: '该项目报名时间已结束，不能报名！',
          type: 'warning'
        })
        return
      }
      await this.getPsuListByComId()
      if (this.isbmflag) {
        this.$message({
          message: '该单位已报名，不能重复报名！',
          type: 'warning'
        })
        // this.bmDisplay = false
        return
      }
      this.dialogVisible = true
      this.dialogType = 2
      // this.dialogWidth = "680px";
      // window.location.replace(`${this.obWebUrl}?t=${this.webLoginUser.token}&formname=psuForm&projectid=${this.pjnotice.pjnoticeprojectid}`)
    },
    async close(val) {
      if (this.dialogType === 2) {
        await this.getPsuListByComId()
      }
      this.dialogVisible = false
      this.dialogType = 0
      // this.dialogWidth = "455px";
      if (val) {
        this.goLink()
      }
    },
    // 去报价
    gobj() {
      if (!this.webLoginUser) {
        this.dialogVisible = true
        this.dialogType = 1
        return
      }
      if (!this.isbmflag) {
        this.$message({
          message: '该供应商未报名!',
          type: 'warning'
        })
        // this.bmDisplay = false
        return
      }

      if (+this.webLoginUser.comtype !== 3) {
        this.$message({
          message: '您不是供应商角色，不能报价！',
          type: 'warning'
        })
        return
      }
      if (+this.pjnotice.btnstatus !== 4) {
        this.$message({
          message: '该项目报价时间已结束！',
          type: 'warning'
        })
        return
      }
      window.location.replace(`${this.obWebUrl}?t=${this.webLoginUser.token}&formname=biddingHall&menuid=81`)
    },
    // 已报名清单
    goybm() {
      window.location.replace(`${this.obWebUrl}?t=${this.webLoginUser.token}&formname=psuIndex&menuid=48`)
    },
    async gobm() {
      if (!this.webLoginUser) {
        this.dialogVisible = true
        this.dialogType = 1
        return
      }
      this.goLink()
      // this.dialogVisible = true
      // this.dialogType = 2
    },
    open(index) {
      if (this.activeIndex === index) {
        this.activeIndex = ''
      } else {
        this.activeIndex = index
      }
    },
    getDebounceList: _.debounce(function () {
      this.getpjnotice()
    }, 300),
    returnPre(val) {
      // 返回首页
      if (val === 0) {
        this.$router.replace({ path: '/' })
      }
    },
    uploadAddr() {
      return this.$store.getters.picAddr
    },
    async getOtherNotice() {
      let { pjnoticeid, projectid } = this.$route.query
      let res = await request({
        url: '/web/web/getOtherPjnotice',
        method: 'get',
        params: {
          pjnoticeid, projectid
        }
      })

      this.otherNotice = res || []
    },
    toProjectInfo(val) {
      let { pjnoticeid, pjnoticeprojectid } = val
      let { href } = this.$router.resolve({
        name: "pjnoticeInfo",
        query: { pjnoticeid, projectid: pjnoticeprojectid },
      });
      window.open(href, "_blank");
    }
  },
  computed: {
    ...mapGetters(['parentActiveTab', 'childActiveTab', 'cosId', 'webLoginUser', 'obWebUrl', 'picAddr']),
    prsname() {
      if (+this.pjnotice.prsflg === 1 || +this.pjnotice.prsflg === 3) {
        return '去竞价'
      } else if (+this.pjnotice.prsflg === 2) {
        return '去投标'
      } else if (+this.pjnotice.prsflg === 4 || +this.pjnotice.prsflg === 5) {
        return '去竞拍'
      } else {
        return '去比选'
      }
    }
  }
}
</script>



<style lang="scss" scoped>
/* table 样式 */

@import '../styles/variables.scss';
@import '@/styles/table.scss';

/*.pjnoticeCon{*/
/*width: 100%;*/
/*}*/
.el-dialog {
  width: 100% !important;
}

.page2_wrapper {
  .container {
    padding: 40px 0;
    display: flex;
    justify-content: center;

    .main {
      width: 1201px;
      display: flex;
      justify-content: center;

      .right {
        flex: 1;
        background-color: $color-bg-white;
        margin-left: 15px;

        .breadcrumb {
          padding: 25px 0 10px;
          margin: 0 20px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #fafafa;

          .lable {
            padding-right: 10px;
            color: $color-text-secondary-gray;
          }

          .breadcrumb_item {
            display: flex;
            justify-items: center;
            cursor: pointer;

            :last-child {
              color: $color-text-secondary-gray;
              cursor: text;
            }

            span {
              margin: 0 5px;
            }

            .breadcrumb_item_title {
              width: 380px;
              list-style: none;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }

        .groupbtn {
          display: flex;
          justify-content: flex-end;
          padding: 20px 20px 10px 20px;

          .countdown {
            padding-left: 20px;
          }
        }

        .alertmsg {
          color: red;
          text-align: right;
          padding-right: 20px;
        }

        .pjnoticeTitle {
          font-weight: bolder;
          font-size: 20px;
          padding: 30px 0;
          text-align: center;
          border-bottom: 1px solid #ccc;
        }

        .content {
          padding: 15px 20px;
          line-height: 28px;
        }

        .filelist {

          /*width: 100%;*/
          .fileitem {
            display: flex;
            text-align: left;

            .name {
              color: #2f74ff;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}

.noticlink {
  color: rgb(96, 94, 94);
  font-style: italic;
}

.noticlink:hover {
  text-decoration: underline;
  color: #f46722;
}
</style>
